
import { getPropertyByKey } from '../../helper/utils/getPropertyByKey';
import { isEmptyObject } from '../../helper/utils/isEmptyObject';
import { getItemsNoVoid, getPriceMenuService } from './menuItem';
import { manualRounded } from './rounded';
import { isTax } from './tax';

export function isService(salesOrderData) {
    if (isEmptyObject(salesOrderData)) {
        return false;
    }

    return salesOrderData['cService'] === true;
}

export function isServiceBeforeDiscount() {
    return getPropertyByKey('SrvBeforeDiskon') == true; //* Ambil dari proeprty
}

export function servicePrc() {
    return parseFloat(getPropertyByKey('ServPrc') || '0'); //* Ambil dari proeprty
}

export function showServicePrconBill() {
    return getPropertyByKey('ServPrcOnBill') == 1;
}

export function serviceValueMenu(menu = {}, salesOrderData = {}) {
    if (isEmptyObject(menu) || !(isService(salesOrderData) && menu['cService'] == true)) {
        return 0;
    }

    const price = parseFloat(menu[`Price${salesOrderData['SalesTypeCode']}`].toString()) || 0;
    const qty = parseFloat((menu['qty'] || 0).toString()) || 0;
    const discVal = parseFloat((menu['discVal'] || 0).toString()) || 0;

    if (qty == 0) {
        return 0;
    }

    if (isServiceBeforeDiscount()) {
        // return Math.round(qty * price * (servicePrc() / 100));
        // return qty * price * (servicePrc() / 100);
        return manualRounded(qty * price * (servicePrc() / 100));
    } else {
        // return Math.round((price - discVal) * qty * (servicePrc() / 100));
        // return (price - discVal) * qty * (servicePrc() / 100);
        return manualRounded((price - discVal) * qty * (servicePrc() / 100));
    }
}

export function totalServiceValue(items = [], salesOrderData = {}) {
    if (items.length > 0) {
        if (isTax(salesOrderData)) {
            const services = getItemsNoVoid(items)?.map((item) => getPriceMenuService(item));
            const serv = services.reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0);

            // return Math.round(serv);
            return serv;
        }
    }

    return 0;
}
